import Store from './Store'
import { action, flow, makeObservable, observable } from 'mobx'
import ClientService from '../services/ClientService'
import Paginator from '../models/Paginator'
import ClientsSynced from '../models/ClientsSynced'

class SyncedStore extends Store {
  /**
   * @type {array<ClientsSynced>}
   */
  @observable syncedList = []

  @observable paging = {}
  @observable _tmpQuery = {}

  constructor () {
    super()
    makeObservable(this)
    this._tmpQuery = sessionStorage.getItem('synchedStore')
      ? JSON.parse(sessionStorage.getItem('synchedStore'))
      : {}
    this.sendFilters()
  }

  @flow
  * loadAll () {
    this.isLoading = true
    const result = yield ClientService.getSynceds(this.query)
    this.paging.ClientsSynced = new Paginator(result.paginator.ClientsSynced)
    this.syncedList = []
    for (const client of result.clients) {
      this.syncedList.push(new ClientsSynced(client))
    }
    this.isLoading = false
  }

  @flow
  * loadOne (clientId) {
    this.isLoading = true
    const result = yield ClientService.getSynced(clientId)
    this.syncedList = []
    for (const client of result.clients) {
      this.syncedList.push(new ClientsSynced(client))
    }
    this.isLoading = false
  }

  /**
   * @param clientId
   */
  @flow
  * import (clientId) {
    this.isLoading = true
    const response = yield ClientService.importSynced(clientId)
    this.isLoading = false
    if (response.result.success === undefined || !response.result.success) {
      this.errorMessage = response.result.message
      throw new Error(response.result.message)
    } else {
      return response.result
    }
  }

  @action
  changePage (newPage) {
    if (newPage <= this.paging.ClientsSynced.pageCount && newPage > 0) {
      this.paging.ClientsSynced.page = newPage
      this.query.page = newPage
    }
  }

  @action
  sendFilters () {
    for (const [key, value] of Object.entries(this._tmpQuery)) {
      this.query[key] = value
    }
    this.query.page = 1
    sessionStorage.setItem('synchedStore', JSON.stringify(this._tmpQuery))
    this.syncedList = []
  }

  @action
  clearFilters () {
    this._tmpQuery = {}
    this.query = {}
    this.syncedList = []
    sessionStorage.removeItem('synchedStore')
  }
}

export default SyncedStore
